import { Box, Tooltip, Typography } from "@mui/material";
import { AddTask } from "@mui/icons-material";
import { extractPlainTextPreview } from "../../../../utils/removeHtmlTagsAndEntities";
import { formatDateCompact } from "../../../../utils/dateUtils";
import { ColoredLabelChip } from "../../../../components/chips/ColoredLabelChip";
import { BaseTimelineItem } from "./BaseTimelineItem";
import type { LogbookTaskTimelineItem } from "../../types";

type LogbookTaskItemProps = {
	task: LogbookTaskTimelineItem;
	isSelected: boolean;
	onClick: () => void;
	linkUrl?: string;
};

const taskAccent = "#7b1fa2";

export const LogbookTaskItemComponent = ({ task, isSelected, onClick, linkUrl }: LogbookTaskItemProps) => {
	const { fullPlainText, preview } = extractPlainTextPreview(task.content ?? "");
	const dateLabel = formatDateCompact(task.date_created);
	const isDone = task.status === "done";

	return (
		<BaseTimelineItem config={{
			accentColor: taskAccent,
			icon: <AddTask sx={{ fontSize: 14, color: taskAccent }} />,
			isSelected,
			linkUrl,
		}}>
			<Box onClick={onClick} sx={{ flex: 1, cursor: "pointer" }}>
				<Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
					<Typography variant="body2" fontWeight={600} color={taskAccent}>Tarefa</Typography>
					<Box sx={{ transform: "scale(0.8)", transformOrigin: "left center", display: "flex", gap: 0.5, alignItems: "center" }}>
						<ColoredLabelChip
							label={isDone ? "Concluída" : "Aberta"}
							color={isDone ? "#4BC417" : "#1A7FEA"}
						/>
					</Box>
				</Box>
				<Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: "block", fontSize: "0.65rem" }}>
					{dateLabel}
				</Typography>
				<Box sx={{ mt: 0.5 }}>
					<Tooltip title={fullPlainText} placement="bottom-start" enterDelay={500}>
						<Typography variant="body2" color="text.secondary">{preview}</Typography>
					</Tooltip>
				</Box>
			</Box>
		</BaseTimelineItem>
	);
};
